import {
    createElement,
    type ComponentPropsWithoutRef,
    type ElementType,
    type ReactNode,
} from "react";

type CardProps<T extends ElementType> = {
    as?: T;
    className?: string;
    children: ReactNode;
} & Omit<ComponentPropsWithoutRef<T>, "as" | "className" | "children">;

export default function Card<T extends ElementType = "div">({
    as,
    className = "",
    children,
    ...props
}: CardProps<T>) {
    return createElement(
        as ?? "div",
        {
            ...props,
            className: [
                "rounded-2xl border border-border/80 bg-card",
                className,
            ]
                .filter(Boolean)
                .join(" "),
        },
        children,
    );
}
